import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
// import OperationIconA from '../../../../assets/images/oparation_a.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPaperclip, faFileArrowDown, faPaperPlane, faUpload, faFilter, faFileLines, faEllipsisVertical, faPencilAlt, faCircle } from '@fortawesome/free-solid-svg-icons';
import { Form, Button, Accordion, Row, Col, Modal, Table, Tabs, Tab, Dropdown } from 'react-bootstrap';
import { withRFSToken } from '../../../../Services/axios';
import { GETDESTINATION, GETOWNERCODE } from '../../../../Utils/conts';
import { Link } from 'react-router-dom';
import Select from 'react-select';
import { toast } from 'react-toastify';

import AssetsIcon from '../../../../assets/images/oparation.svg';
import Radown from "../../../../assets/images/radown.png";
import AssetsIconw from '../../../../assets/images/oparation_a.svg';
import Docmnt from '../../../../assets/images/file.svg';
import Pack from '../../../../assets/images/n_package.png';
import Uploadn from '../../../../assets/images/upload-n.png';
import Uploadw from '../../../../assets/images/upload-w.png';
import Trash from "../../../../assets/images/trash.png";
import Shipupload from "../../../../assets/images/ship_upload.png";
import view from "../../../../assets/images/view.png";
import cargohub_logo from "../../../../assets/images/cargohub-logo.png";
import mail from "../../../../assets/images/mail.png";
import xls_file from "../../../../assets/images/xls-file.png";
import dwnld from "../../../../assets/images/dwnld.png";
import { saveAs } from "file-saver";
import { decrypt } from '../../../../Utils/cryptoStorage';


const Import = () => {

    // const incotermOption = [
    //         { label: '--', value: '-' },
    //     { label: 'EXW - Ex Works', value: 'EXW' },
    //     { label: 'FCA - Free Carrier', value: 'FCA' },
    //     { label: 'FAS - Free Alongside Ship', value: 'FAS' },
    //     { label: 'FOB - Free On Board', value: 'FOB' },
    //     { label: 'CPT - Carriage Paid To', value: 'CPT' },
    //     { label: 'CIP - Carriage and Insurance Paid', value: 'CIP' },
    //     { label: 'CFR - Cost and Freight', value: 'CFR' },
    //     { label: 'CIF - Cost Insurance and Freight', value: 'CIF' },
    //     { label: 'DAP - Delivered At Place', value: 'DAP' },
    //     { label: 'DPU - Delivered At Place Unloaded', value: 'DPU' },
    //     { label: 'DDP - Delivered Duty Paid', value: 'DDP' }
    // ];
    const incotermOption = [
        { label: '--', value: '-' },
        { label: 'Inspection VWA', value: 'VWA' },
        { label: 'Inspection PD', value: 'PD' },
    ];
    const acceptanceWarehouseInhandlerOptions = [
        { label: '--', value: '-' },
        { label: 'Transfer', value: 'Transfer' },
        { label: 'NCTS', value: 'NCTS' },
        { label: 'IM4', value: 'IM4' },

    ];
    const acceptanceWarehouseOuthandlerOptions = [
        { label: '--', value: '-' },
        { label: 'Transfer', value: 'Transfer' },
        { label: 'NCTS', value: 'NCTS' },
        { label: 'IM4', value: 'IM4' },

    ];
    const TransportShipmentType = [
        { label: '--', value: '-' },
        { label: 'Inspection VWA', value: 'Inspection VWA' },
        { label: 'Inspection PD', value: 'Inspection PD' },
    ];
    const VwsShipmentClass = [
        { label: '--', value: '-' },
        { label: 'Human consumption  HC)', value: 'HC' },
        { label: 'Non Human Consumption (NHC)', value: 'NHC' },
        { label: 'Live animals (AVI)', value: 'AVI' },
    ];
    const isMounted = useRef(false);
    const [formData, setFormData] = useState({
        master_airwaybill: "",
        hawb: "",
        job_nr: "",
        incoterm: "",
        origin_airport: "",
        airline_name: "",
        customer_name: "",
        shipper: "",
        consignee: "",
        reference: "",
        pieces: "",
        gross_weight: "",
        chargeable_weight: "",
        volume: "",

        trucking_buying: "",
        trucking_selling: "",
        trucking_currency: "",
        courier_buying: "",
        courier_selling: "",
        courier_currency: "",
        dg_buying: "",
        dg_selling: "",
        dg_currency: "",

        // haulier: "",
        // instructions: "",
        // delivery_reference_nr: "",
        // slottime: "",
        // booked_for_delivery: "",
        // delivered: "",
        // pod_received: "",
        // delivery_remarks: "",
        flight_details: [
            { id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', etd: '', etd: '' }
        ],


        eta: "",
        ata: "",
        noa: "",
        pickup_airline: "",
        inbound_whs: "",
        ci_pl: "",
        hs_code: "",
        atr_rex: "",
        atr_received: "",
        quote_received: "",
        received_dn: "",
        invoiced: "",
    });
    const currencies = [
        { value: "EUR", label: "EUR (€) - Euro" },
        { value: "USD", label: "USD ($) - US Dollar" },
        { value: "PHP", label: "PHP (₱) - Philippine Peso" },
        { value: "JPY", label: "JPY (¥) - Japanese Yen" },
        { value: "GBP", label: "GBP (£) - British Pound" },
        { value: "AUD", label: "AUD (A$) - Australian Dollar" },
        { value: "CHF", label: "CHF (Fr.) - Swiss Franc" },
        { value: "CAD", label: "CAD (C$) - Canadian Dollar" },
        { value: "MXN", label: "MXN ($) - Mexican Peso" },
        { value: "CNY", label: "CNY (¥) - Chinese Yuan" },
        { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar" },
        { value: "SEK", label: "SEK (kr) - Swedish Krona" },
        { value: "RUB", label: "RUB (₽) - Russian Ruble" },
        { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar" },
        { value: "NOK", label: "NOK (kr) - Norwegian Krone" },
        { value: "SGD", label: "SGD (S$) - Singapore Dollar" },
        { value: "TRY", label: "TRY (₺) - Turkish Lira" },
        { value: "KRW", label: "KRW (₩) - South Korean Won" },
        { value: "ZAR", label: "ZAR (R) - South African Rand" },
        { value: "BRL", label: "BRL (R$) - Brazilian Real" },
        { value: "INR", label: "INR (₹) - Indian Rupee" },
        { value: "SAR", label: "SAR (﷼) - Saudi Riyal" },
        { value: "DKK", label: "DKK (kr) - Danish Krone" },
        { value: "RON", label: "RON (lei) - Romanian Leu" },
        { value: "XAF", label: "XAF (Fr) - Central African CFA Franc" },
        { value: "XOF", label: "XOF (Fr) - West African CFA Franc" },
        { value: "DOP", label: "DOP (RD$) - Dominican Peso" },
        { value: "HTG", label: "HTG (G) - Haitian Gourde" },
        { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar" },
        { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar" },
        { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar" },
        { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder" },
        { value: "COP", label: "COP (COL$) - Colombian Peso" },
        { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights" },
        { value: "XBT", label: "XBT (₿) - Bitcoin" },
        { value: "WGH", label: "WGH - West German Hard Currency" }
    ];

    const [getDestination, setGetDestination] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const [userList, setUserList] = useState([]);
    const [getOwnerCodes, setGetOwnerCode] = useState([]);
    const [authData, setAuthData] = useState();
    // const userId = localStorage.getItem('Email')

    const fetchDestination = async () => {
        try {

            const res = await withRFSToken.post(GETDESTINATION, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.port_code,
                        label: item.port_code,
                        address: item.address,
                        station_id: item.station_id
                    })) : [];
                    setGetDestination(transformedData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchOwnerCode = async () => {
        try {
            const res = await withRFSToken.post(GETOWNERCODE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.IATA,
                        label: item.IATA,
                        airline_name: item.airline_name
                    })) : [];
                    setGetOwnerCode(transformedData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchUser = async (edidId) => {
        try {

            const res = await withRFSToken.get(`uld-setting/get-user-list`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.user_id,
                        label: item.first_name + ' ' + item.last_name,
                        email: item.email_id,
                    })) : [];
                    setUserList(transformedData);
                    // if (innerData.length > 0) {
                    if (!edidId) {
                        const isDefault = innerData?.find(dflt => dflt.email_id == authData?.email_id)
                        setFormData(prevFormData => ({ ...prevFormData, assigned_to: isDefault?.user_id }))
                    } else {
                        const res = withRFSToken.post(`shipment/import-shipment-record-details/${edidId}`, {})
                            .then(function (res) {
                                const innerDatas = res.data.response_data;
                                // setSelectedRowData(innerData);
                                // const isDefault = innerData?.find(dflt => dflt.email_id == userId)
                                console.log("🚀 ~ isDefault:", innerData)
                                const transformData = {
                                    ...innerDatas,
                                    // assigned_to: innerDatas.assigned_to == null ? isDefault?.user_id : innerData.assigned_to,
                                    // dimensions: innerDatas.dimensions?.length > 0 ? innerDatas.dimensions : [{ id: '1', pieces: '', length: '', width: '', height: '', }],
                                    flight_details: innerDatas?.flight_details?.length > 0 ? innerDatas.flight_details : [{ id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', etd: '', etd: '' }] || [{ id: '1', flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', etd: '', etd: '' }],
                                    setting_status: innerDatas?.setting_status?.id,
                                    setting_department: innerDatas?.setting_department?.id,
                                }
                                setFormData(transformData)
                            });
                    }

                    // }

                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchStatus = async () => {
        try {

            const res = await withRFSToken.get(`shipment/get-settings?tab=import&type=S`, {})
                .then(function (res) {
                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setStatusList(transformedData);
                    if (innerData.length > 0) {
                        const isDefault = innerData?.find(dflt => dflt.is_default === 1)
                        setFormData(prevFormData => ({ ...prevFormData, setting_status: isDefault.id }))
                    }

                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDepartment = async () => {
        try {

            const res = await withRFSToken.get(`shipment/get-settings?tab=import&type=D`, {})
                .then(function (res) {

                    const innerData = res.data.Rows;
                    const transformedData = innerData ? innerData.map(item => ({
                        value: item.id,
                        label: item.name,
                    })) : [];
                    setDepartmentList(transformedData);
                    //   console.log("trans",transformedData);
                });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const loadDetails = async (uldNumber) => {
        // const uldNumber = JSON.parse(localStorage.getItem('SHEdit'));
        try {
            const res = await withRFSToken.post(`shipment/import-shipment-record-details/${uldNumber}`, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // setSelectedRowData(innerData);
                    const isDefault = userList?.find(dflt => dflt.email == authData?.email_id)
                    console.log("🚀 ~ isDefault:", userList)
                    const transformData = {
                        ...innerData,
                        // setting_user: innerData.assigned_to == null ? isDefault?.value : innerData.assigned_to,
                        setting_status: innerData.setting_status?.id,
                        setting_department: innerData.setting_department?.id,
                    }
                    setFormData(transformData)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const ExtractSession = async () => {
        try {
            const encryptedData = sessionStorage.getItem('__A-');
            if (encryptedData) {
                const data = await decrypt(encryptedData);
                setAuthData(data);
            }
        } catch (error) {
            console.error("Session decrypt error:", error);
        } finally {
            // setAuthLoading(false);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        const localData = JSON.parse(localStorage.getItem('SHEdit'));
        // if (localData) {
        //     setFormData(localData);
        // }
        // if (localData) { loadDetails(localData); }
        if (localData) { fetchUser(localData); } else { fetchUser(); }
        fetchStatus();
        fetchDepartment();
        fetchDestination();
        fetchOwnerCode();
        ExtractSession();
        isMounted.current = true;
    }, []);

    const shId = JSON.parse(localStorage.getItem('SHEdit'));


    const [activeStep, setActiveStep] = useState(0);
    const [activeTab, setActiveTab] = useState('All');
    const [selectedButton, setSelectedButton] = useState('general');
    const [sendData, setSendData] = useState({});
    const [checkList, setCheckList] = useState({});

    const [expandedKeys, setExpandedKeys] = useState([]);
    const [base64Files, setBase64Files] = useState([]);
    const [files, setFiles] = useState([]);
    const [rfiles, setRfiles] = useState([]);
    const fileInputRef = useRef(null);
    const fileInputRefs = useRef({});
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [uploadTarget, setUploadTarget] = useState('');
    // useEffect(() => {
    //     setSelectedButton(initialTab);
    // }, [initialTab]);
    // console.log('555', selectedButton);
    const handleButtonClick = async (button) => {
        if (button == 'remarks') { setActiveStep(2) }
        else if (button == 'attachment') {
            setActiveStep(1);
            if (!formData.id && formData.master_airwaybill) {
                try {
                    const res = await withRFSToken.post('shipment/save-import-shipment-record', formData);
                    // console.log('API Response:', res.data);
                    if (res.data.response_code === 200) {
                        localStorage.setItem('SHEdit', JSON.stringify(res.data.response_data.id));
                        setFormData(res.data.response_data);
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            }
        }
        else { setActiveStep(0) }
        setSelectedButton(button);
    };

    const handleTabChange = async (tab) => {
        setActiveTab(tab);
    }

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    }
    const handleDownload = async (imageUrl, imageName) => {
        const path = extractPath(imageUrl);
        const res = await withRFSToken
            .post("get-file-blob", {
                file_path: path,
            })
            .then((response) => {
                const pdfData = atob(response.data.response_data.file_base64);
                const byteNumbers = new Array(pdfData.length);
                for (let i = 0; i < pdfData.length; i++) {
                    byteNumbers[i] = pdfData.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                    type: response.data.response_data.mime_type,
                });
                saveAs(blob, imageName);
            })
            .catch((error) => {
                console.error("Error during the file download:", error);
                alert("Could not download the file");
            });
    };
    const toggleAccordionItem = async (index, msg, pos) => {

        setExpandedKeys(prevKeys =>
            prevKeys.includes(index.toString())
                ? prevKeys.filter(key => key !== index.toString()) // Remove key to collapse
                : [...prevKeys, index.toString()] // Add key to expand
        );
    };

    const conversationChange = (event) => {
        const { name, value, } = event.target;
        setSendData(prevFormData => {
            const newFormData = { ...prevFormData, [name]: value };

            return newFormData;
        });
    }
    // IMAGE UPLOAD START
    const imageModalUpload = () => {
        setShowModalUpload(true);
    }
    const closeModalUpload = () => {
        setShowModalUpload(false);
        setFiles([])
        setBase64Files([])
    }
    const handleDrop = (e) => {
        e.preventDefault();
        console.log('E', e);

        const droppedFiles = Array.from(e.dataTransfer.files);
        const selectedFiles = Array.from(e.dataTransfer.files);
        const filesWithBase64 = [];
        let filesProcessed = 0;

        // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
        const existingBase64Files = formData?.base64Files || [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
                filesProcessed += 1;
                if (filesProcessed === selectedFiles.length) {
                    const newFiles = filesWithBase64.map((obj) => obj.file);
                    // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    let newBase64Files;
                    if (uploadTarget) {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [uploadTarget] }));
                    } else {
                        newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                    }
                    const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                    // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files(mergedBase64Files);
                    setSendData((prevFormData) => {
                        // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                        const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                        return newFormData;
                    });
                }
            };
            reader.readAsDataURL(file);
        });
        // setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        // getBase64(droppedFiles[0]);
    };
    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index, pos) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        if (pos == 'R') {
            setRfiles((prevFiles) => {
                const newFiles = [...prevFiles];
                newFiles.splice(index, 1);
                return newFiles;
            });
        }
        // base64Files.splice(index, 1);
        setBase64Files((prevBase64Files) => {
            const newBase64Files = [...prevBase64Files];
            newBase64Files.splice(index, 1);
            if (pos == 'R') {

                setSendData((prevFormData) => {
                    // const newFiles = [...prevFormData.files];
                    const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
                    newFiles.splice(index, 1);
                    return { ...prevFormData, files: newFiles };
                });
            }
            // Update local storage


            return newBase64Files;
        });
    };

    const handleBrowseFiles = (e, nam) => {
        e.preventDefault();
        console.log('fileInputRef.current', fileInputRef);
        if (nam) {
            if (fileInputRefs.current[nam]) {
                fileInputRefs.current[nam].click();
            }
        } else { fileInputRef.current.click(); }
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleChecklicstChange = (e) => {
        const { value, checked } = e.target;
        setCheckList(prevFormData => {
            let updatedSpecifications = [...(prevFormData.check_list || [])];
            if (checked) {
                updatedSpecifications.push(value); // Add selected option
            } else {
                updatedSpecifications = updatedSpecifications.filter(spec => spec !== value); // Remove unselected option
            }
            return {
                ...prevFormData,
                check_list: updatedSpecifications,
            };
        });
    }
    const handleFileChange = (e, pos, chk) => {
        if (formData.id) {
            const selectedFiles = Array.from(e.target.files);
            const filesWithBase64 = [];
            let filesProcessed = 0;

            // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
            const existingBase64Files = formData?.base64Files || [];

            selectedFiles.forEach((file) => {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    if (file.size > 26214400) {
                        toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
                        return;
                    }
                    filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
                    filesProcessed += 1;
                    if (filesProcessed === selectedFiles.length) {
                        // if (pos === 'C') { // pos === 'A' || 
                        //     // const newFiles = filesWithBase64.map((obj) => obj.file);
                        //     // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
                        //     const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                        //     const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
                        //     // setFiles(newFiles);


                        //     const payload = {
                        //         shipmen_id: formData.id,
                        //         shipmen_type: "export",
                        //         attachments: mergedBase64Files
                        //     }
                        //     // console.log('payload', payload);
                        //     try {
                        //         const res = await withRFSToken.post('shipment/upload-doc', payload);
                        //         console.log('API Response:', res.data);
                        //         if (res.data.response_code === 200) {
                        //             toast.success(res.data.response_msg);
                        //             setFormData(res.data.response_data);
                        //         } else {
                        //             toast.error(res.data.response_msg);
                        //         }
                        //     } catch (error) {
                        //         console.error('Error saving shipment record:', error);
                        //     }

                        // } else {
                        const newFiles = filesWithBase64.map((obj) => obj.file);
                        console.log("🚀 ~ reader.onloadend= ~ newFiles:", filesWithBase64);
                        let newBase64Files;
                        if (pos === 'C') {
                            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
                        } else {
                            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                        }
                        console.log('newBase64Files', newBase64Files);

                        // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
                        const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

                        // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                        setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                        setBase64Files(mergedBase64Files);
                        if (pos == 'R') {
                            setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
                            setSendData((prevFormData) => {
                                // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
                                const newFormData = { ...prevFormData, attachments: mergedBase64Files };

                                return newFormData;
                            });
                        }

                        // }
                    }
                };
                reader.readAsDataURL(file);
            });
        } else {
            toast.error('Please add AwbNumber first')
        }

    };
    const imageUpload = async () => {
        // setGridSelect(prevGridSelect =>
        //     prevGridSelect.map(item => {
        //         if (item.uid === selectedRowId) {
        //             return { ...item, files: files, base64Files: base64Files };
        //         }
        //         return item;
        //     })
        // );
        // setShowModalUpload(false);
        const payload = {
            shipmen_id: formData.id,
            shipmen_type: "import",
            attachments: base64Files
        }
        // console.log('payload', payload);
        try {
            const res = await withRFSToken.post('shipment/upload-doc', payload);
            console.log('API Response:', res.data);
            if (res.data.response_code === 200) {
                toast.success(res.data.response_msg);
                setFormData(res.data.response_data);
                setShowModalUpload(false);
                setFiles([])
                setUploadTarget('');
                setBase64Files([]);
            } else {
                toast.error(res.data.response_msg);
            }
        } catch (error) {
            console.error('Error saving shipment record:', error);
        }
    };
    // IMAGE UPLOAD END
    const handleInputChange = (name, value) => {
        if (name === 'master_airwaybill') {
            value = handleChange(value);
        }
        setFormData({
            ...formData,
            [name]: value,
        });
        // if (actionMeta) {

        //     setFormData({
        //         ...formData,
        //         [actionMeta.name]: e ? e.value : "",
        //     });
        //     console.log(formData);
        // } else {
        //     const { name, value } = e.target;

        //     console.log(formData);
        // }
    };
    const handleChange = (value) => {
        value = value.replace(/[^\d]/g, ''); // Remove any non-numeric characters
        let formattedValue = '';

        // Add a hyphen after the third character
        if (value.length > 3) {
            formattedValue += value.substr(0, 3) + '-';
            value = value.substr(3);
        }

        // Add a space after the eighth character
        if (value.length > 4) {
            formattedValue += value.substr(0, 4) + ' ';
            value = value.substr(4);
        }

        formattedValue += value;
        return formattedValue.substr(0, 13);
    };
    const validateFormData = () => {
        let isValid = true;
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // Function to validate email
        // const validateEmail = (email) => {
        //     return emailRegex.test(email);
        // };
        if (!formData.master_airwaybill) {
            // toast.error('Please enter Shipper');
            isValid = false;
        }
        else {
            return isValid;
        }
    };
    const handleSubmit = async () => {
        if (validateFormData()) {
            // console.log('formData===>', formData)
            let transData = {};
            // let endpoint = ''
            // if (formData.id) {
            //     endpoint = `shipment/update-import-shipment-record/${formData.id}`
            //     const { id, ...rest } = formData;
            //     transData = rest;
            // } else {
            //     endpoint = 'shipment/save-import-shipment-record'
            //     transData = formData
            // }
            if (activeStep === 2) {
                transData = { ...formData, remarks: sendData }
            } else {
                transData = formData
            }
            try {
                const res = await withRFSToken.post('shipment/save-import-shipment-record', transData);
                // console.log('API Response:', res.data);
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg)
                    window.location.href = '/ForwarderShipments/ShipmentRecords'
                } else {
                    toast.error(res.data.response_msg);
                }
            } catch (error) {
                console.error('Error saving shipment record:', error);
            }
        } else {
            toast.error('Please add Master Airwaybill first');
        }
    };

    const [typeModal, setTypeModal] = useState(false);
    const [modalSection, setModalSection] = useState('');
    const [modalData, setModalData] = useState({});
    const [typeData, setTypeData] = useState('');

    const handleOpenModal = (pos, data) => {
        setModalData(data);
        setTypeModal(true);
        setModalSection(pos);
        setTypeData(data.category[0])
    }
    const modalChange = (e) => {
        setTypeData(e.target.value);
    }
    const modalUpdate = async () => {
        if (modalSection === 'S') {
            if (typeData !== null) {
                const payload = {
                    shipmen_id: shId,
                    shipmen_type: 'import',
                    action_type: 'update',
                    file_id: modalData.file_id,
                    category: [typeData]
                }
                // console.log(payload);
                try {
                    const res = await withRFSToken.post('shipment/update-doc', payload);
                    if (res.data.response_code === 200) {
                        setFormData(res.data.response_data);
                        toast.success(res.data.response_msg)
                        setTypeModal(false);
                    } else {
                        toast.error(res.data.response_msg)
                    }
                } catch (error) {
                    console.error('Error saving shipment record:', error);
                }
            } else {
                toast.error('Please change the type first')
            }
        } else {
            const payload = {
                shipmen_id: shId,
                shipmen_type: 'import',
                action_type: 'delete',
                file_id: modalData.file_id
            }
            // console.log(payload);
            try {
                const res = await withRFSToken.post('shipment/update-doc', payload);
                if (res.data.response_code === 200) {
                    setFormData(res.data.response_data);
                    toast.success(res.data.response_msg)
                    setTypeModal(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            } catch (error) {
                console.error('Error saving shipment record:', error);
            }
        }

    }
    const addFlight = () => {
        const lastId = formData.flight_details.length > 0 ? parseInt(formData.flight_details[formData.flight_details.length - 1].id) : 0;
        const newId = (lastId + 1).toString();
        setFormData(prevFormData => ({
            ...prevFormData,
            flight_details: [
                ...prevFormData.flight_details,
                {
                    id: newId,
                    flight_code: '', flight_number: '', flight_date: '', origin: '', destination: '', etd: '', etd: ''
                }
            ]
        }));
    };

    const removeFlight = (dimensionId) => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                flight_details: prevFormData.flight_details.filter(stack => stack.id !== dimensionId)
            };
        });
    };
    const handleFlChange = (flightId, fieldName, value) => {
        setFormData(prevFormData => ({
            ...prevFormData,
            flight_details: prevFormData.flight_details.map(stack => {
                if (stack.id === flightId) {
                    const updatedStack = { ...stack, [fieldName]: value };
                    return updatedStack;
                }
                return stack;
            })
        }));
    }

    // Add this state for tab selection
    const [selectedTab, setSelectedTab] = useState('details');

    const isStepComplete = (stepName) => {
        switch (stepName) {
            case 'eta':
                return formData.eta && formData.eta.trim() !== '';
            case 'ata':
                return formData.ata && formData.ata.trim() !== '';
            case 'noa':
                return formData.noa && formData.noa.trim() !== '';
            case 'pickup':
                return formData.pickup_airline && formData.pickup_airline.trim() !== '';
            case 'warehouseIn':
                return formData.warehouse_in && formData.warehouse_in.trim() !== '';
            case 'warehouseOut':
                return formData.warehouse_out && formData.warehouse_out.trim() !== '';
            default:
                return false;
        }
    };

    return (
        <>
            {console.log('formData', formData)}
            <div className='shipment_tab'>
                <div className="mt-3 ">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="viewbooks" style={{}}>
                                <h4 className='d-flex align-items-center justify-content-between'>Import Record - {formData.cargohub_id} <span><button><FontAwesomeIcon icon={shId ? faPencilAlt : faPaperPlane} className='pe-1' onClick={() => handleSubmit('S')} />{shId ? 'Edit' : 'Submit'}</button></span></h4>
                                <p><span><b>Created On :</b> </span>{formData?.created_at?.split('T')[0].split('-').reverse().join('-')}</p>
                                <p className='d-flex justify-content-between'><span><b>Status : <span style={{ color: '#FC8430' }}>Accepted</span></b></span><span><b>Storage Location: <span>AMS_asd</span></b></span></p>
                            </div>

                        </div>

                        <div className="col-md-9">
                            <div className="viewbooks" style={{}}>
                                {/* Progress Bar */}
                                <div className="mt-1">
                                    <div className="d-flex justify-content-between align-items-start position-relative">

                                        <div className="Progress_Line" style={{ backgroundColor: '#ccc' }}></div>
                                        {/* Step 1 - ETA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('eta') ? "step_complete" : "step_incomplete"} style={{}}>
                                                1
                                            </div>
                                            <div className={isStepComplete('eta') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>ETA</div>
                                                <div>{formData.eta ? formData.eta.replace('T', ' ') : ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 2 - ATA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('ata') ? "step_complete" : "step_incomplete"} style={{}}>
                                                2
                                            </div>
                                            <div className={isStepComplete('ata') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>ATA</div>
                                                <div>{formData.ata ? formData.ata.replace('T', ' ') : ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 3 - NOA */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('noa') ? "step_complete" : "step_incomplete"} style={{}}>
                                                3
                                            </div>
                                            <div className={isStepComplete('noa') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>NOA</div>
                                                <div>{formData.noa ? formData.noa.replace('T', ' ') : ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 4 - Pickup Airline */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('pickup') ? "step_complete" : "step_incomplete"} style={{}}>
                                                4
                                            </div>
                                            <div className={isStepComplete('pickup') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt_incomplete'}>
                                                <div>Pickup Airline</div>
                                                <div>{formData.pickup_airline || ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 5 - Warehouse In */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('warehouseIn') ? "step_complete" : "step_incomplete"} style={{}}>
                                                5
                                            </div>
                                            <div className={isStepComplete('warehouseIn') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt'}>
                                                <div>Warehouse In</div>
                                                <div>{formData.warehouse_in || ''}</div>
                                            </div>
                                        </div>

                                        {/* Step 6 - Warehouse Out */}
                                        <div className="d-flex flex-column align-items-center position-relative flex-grow-1">
                                            <div className={isStepComplete('warehouseOut') ? "step_complete" : "step_incomplete"} style={{}}>
                                                6
                                            </div>
                                            <div className={isStepComplete('warehouseOut') ? 'text-center progress_status_txt_complete' : 'text-center progress_status_txt'}>
                                                <div>Warehouse Out</div>
                                                <div>{formData.warehouse_out || ''}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Row className='mt-3'>
                    <Col sm='3'>
                        <div className='add_shipment'>
                            <button className={selectedButton === 'general' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('general')}>
                                <img src={selectedButton === 'general' ? AssetsIconw : AssetsIcon} /> <span>General</span>
                            </button>
                            <button className={selectedButton === 'attachment' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('attachment')}>
                                <img src={selectedButton === 'attachment' ? AssetsIconw : AssetsIcon} /> <span>Attachments</span>
                            </button>
                            <button className={selectedButton === 'remarks' ? 'exportbtn active' : 'exportbtn'} onClick={() => handleButtonClick('remarks')}>
                                <img src={selectedButton === 'remarks' ? AssetsIconw : AssetsIcon} /> <span>Remarks ({formData?.remarks?.length || 0})</span>
                            </button>
                        </div>

                        {/* {console.log('modalData', formData)}
                        {console.log('typeData', typeData)}
                        {console.log('activeStep', activeStep)} */}
                        {selectedButton === 'general' &&
                            <div className='flbg mt-4 ra_label'>
                                <div className="ship_head">
                                    <h4>Update Status</h4>
                                </div>
                                <Form.Group className="mb-2">
                                    <Form.Label>Cargohub ID </Form.Label>
                                    <Select
                                        // options={userList}
                                        onChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                assigned_to: selected.value
                                            });
                                        }}
                                        placeholder="Cargohub ID"
                                        className='rfs_autoslct'
                                        name="assigned_to"
                                    // value={formData.assigned_to
                                    //     ? userList.find(option => option.value === formData.assigned_to)
                                    //     : null}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Assigned User </Form.Label>
                                    <Select
                                        options={userList}
                                        onChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                assigned_to: selected.value
                                            });
                                        }}
                                        placeholder="User"
                                        className='rfs_autoslct'
                                        name="assigned_to"
                                        value={formData.assigned_to
                                            ? userList.find(option => option.value === formData.assigned_to)
                                            : null}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Status Record</Form.Label>
                                    <Select
                                        options={statusList}
                                        onChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                setting_status: selected.value
                                            });
                                        }}
                                        placeholder="Status"
                                        className='rfs_autoslct'
                                        name="setting_status"
                                        value={formData.setting_status
                                            ? statusList.find(option => option.value === formData.setting_status)
                                            : null}
                                    />
                                </Form.Group>
                                <Form.Group className="mb-2">
                                    <Form.Label>Department </Form.Label>
                                    <Select
                                        options={departmentList}
                                        onChange={(selected) => {
                                            setFormData({
                                                ...formData,
                                                setting_department: selected.value
                                            });
                                        }}
                                        placeholder="Department"
                                        className='rfs_autoslct'
                                        name="setting_department"
                                        value={formData.setting_department
                                            ? departmentList.find(option => option.value === formData.setting_department)
                                            : null}
                                    />
                                </Form.Group>
                            </div>
                        }

                        {selectedButton === 'attachment' &&
                            <div className='flbg mt-4'>

                                <div className="ship_head">
                                    <h4>Document Checklist</h4>
                                </div>
                                <ul className="dock_check">
                                    {["Invoice", "Packinglist", "Emails", "HAWB", "MAWB", "Manifest", "Customs", "Proposal", "Other"].map((name) => (
                                        <li key={name}>
                                            <span>
                                                <Form.Check
                                                    inline
                                                    label={name}
                                                    value={name}
                                                    // id={name}
                                                    name="group1"
                                                    // readOnly
                                                    // onChange={handleChecklicstChange}
                                                    checked={formData?.attachments?.some(chk => chk.category && chk.category.includes(name)) || false}
                                                />
                                            </span>
                                            <span>
                                                {/* <img src={Uploadn} onClick={(e) => handleBrowseFiles(e, name)} /> */}
                                                <img src={Uploadn} onClick={() => { setUploadTarget(name); setShowModalUpload(true); }} />
                                                {/* <input
                                                    type="file"
                                                    ref={(el) => (fileInputRefs.current[name] = el)}
                                                    style={{ display: "none" }}
                                                    name={name}
                                                    onChange={(e) => handleFileChange(e, "C", name)}
                                                    multiple
                                                /> */}
                                            </span>
                                        </li>
                                    ))}
                                </ul>

                            </div>
                        }
                    </Col>
                    <Col sm='9'>
                        <div className='mb-3'>
                            <button
                                className={`exportbtn me-3${selectedTab === 'details' ? ' active' : ''}`}
                                onClick={() => setSelectedTab('details')}
                            >
                                <img src={selectedTab === 'details' ? AssetsIconw : AssetsIcon} /> <span>Details</span>
                            </button>
                            <button
                                className={`exportbtn me-3${selectedTab === 'vwa' ? ' active' : ''}`}
                                onClick={() => setSelectedTab('vwa')}
                            >
                                <img src={selectedTab === 'vwa' ? AssetsIconw : AssetsIcon} /> <span>VWA</span>
                            </button>
                            <button
                                className={`exportbtn me-3${selectedTab === 'customs' ? ' active' : ''}`}
                                onClick={() => setSelectedTab('customs')}
                            >
                                <img src={selectedTab === 'customs' ? AssetsIconw : AssetsIcon} /> <span>Customs</span>
                            </button>
                            <button
                                className={`exportbtn me-3${selectedTab === 'invoice' ? ' active' : ''}`}
                                onClick={() => setSelectedTab('invoice')}
                            >
                                <img src={selectedTab === 'invoice' ? AssetsIconw : AssetsIcon} /> <span>Invoice</span>
                            </button>
                        </div>
                        {/* Content area below the buttons, changes based on selectedTab */}
                        {selectedTab === 'vwa' &&
                            <Row>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Create File</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 1</b></p>
                                        </div>
                                        <ul className="list-unstyled">
                                            <li>
                                                <span>Shipment Type:</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Master AirwayBill :</span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>HAWB :</span>
                                                <span>
                                                    <Form.Control type="text" name="hawb" value={formData.hawb}
                                                        onChange={(e) => handleInputChange('hawb', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Type of goods:</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" />
                                                </span>
                                            </li>


                                            <li>
                                                <span>Expected Pcs :</span>
                                                <span>
                                                    <Form.Control type="number" name="expected_pcs" value={formData.expected_pcs}
                                                        onChange={(e) => handleInputChange('expected_pcs', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Expected Weight :</span>
                                                <span>
                                                    <Form.Control type="number" name="expected_weight" value={formData.expected_weight}
                                                        onChange={(e) => handleInputChange('expected_weight', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Customer:</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" />
                                                </span>
                                            </li>
                                        </ul>
                                        <div className='ship_head'>
                                            <h4>Flight Details</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                            <div className='text-end mt-2 dimension_add'>
                                                <Button variant="primary" >+ Add Customer</Button>
                                            </div>
                                        </div>

                                        {formData?.flight_details?.map((data, index) => (
                                            <>
                                                <div className='flight_section mb-3'>
                                                    <div className='flex_gap'>
                                                        <h4>Flight {index + 1}</h4>
                                                        <div className='imag_trash ms-0 mt-0 align-items-center'>
                                                            {formData.flight_details.length > 1 && (
                                                                <img src={Trash} alt='' onClick={() => removeFlight(data.id)} />
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <Form.Label>Airline Name:</Form.Label>
                                                        <Form.Control type='text' placeholder=''></Form.Control>
                                                    </div>
                                                    <div className='flex_gap'>
                                                        <div>
                                                            <Form.Label>Flight Number</Form.Label>
                                                            <div className='flex_gap'>
                                                                <Select
                                                                    options={getOwnerCodes}
                                                                    onChange={(e) => handleFlChange(data.id, 'flight_code', e.value)}
                                                                    placeholder="flight"
                                                                    className="autoslct"
                                                                    name="flight_code"
                                                                    value={getOwnerCodes.find(option => option.value === data?.flight_code) || ''}
                                                                />
                                                                {/* <Form.Control type="text" className='w-50' placeholder="" /> */}
                                                                <Form.Control type="text" className='fl_wd' placeholder=""
                                                                    value={data.flight_number}
                                                                    onChange={(e) => handleFlChange(data.id, 'flight_number', e.target.value)}
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className='md_flight'>
                                                            <Form.Label>Flight Date</Form.Label>
                                                            <Form.Control type="date" placeholder=""
                                                                value={data.flight_date}
                                                                onChange={(e) => handleFlChange(data.id, 'flight_date', e.target.value)}
                                                            />
                                                        </div>
                                                        <div>
                                                            <Form.Label>Origin</Form.Label>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(e) => handleFlChange(data.id, 'origin', e.value)}
                                                                placeholder="origin"
                                                                className="autoslct"
                                                                name="origin"
                                                                value={getDestination.find(option => option.value === data?.origin) || ''}
                                                            />
                                                            {/* <Form.Control type="text" placeholder="" /> */}
                                                        </div>
                                                        <div>
                                                            <Form.Label>Destination</Form.Label>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(e) => handleFlChange(data.id, 'destination', e.value)}
                                                                placeholder="Destination"
                                                                className="autoslct"
                                                                name="destination"
                                                                value={getDestination.find(option => option.value === data?.destination) || ''}
                                                            />
                                                            {/* <Form.Control type="text" placeholder=""
                                                                value={data.width}
                                                                onChange={(e) => handleFlChange(data.id, 'width', e.target.value)}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                    <div className='flex_gap'>
                                                        <div className='w-50'>
                                                            <Form.Label>ETD</Form.Label>
                                                            <Form.Control type="datetime-local" placeholder=""
                                                                value={data.etd}
                                                                onChange={(e) => handleFlChange(data.id, 'etd', e.target.value)}
                                                            />
                                                        </div>
                                                        <div className='w-50'>
                                                            <Form.Label>ETA</Form.Label>
                                                            <Form.Control type="datetime-local" placeholder=""
                                                                value={data.eta}
                                                                onChange={(e) => handleFlChange(data.id, 'eta', e.target.value)}
                                                            />
                                                        </div>

                                                    </div>
                                                    {/* {index === 0 &&
                                                        <div className='flex_gap'>
                                                            <div className='w-50'>
                                                                <Form.Label>LAT (Latest Acceptance Time)</Form.Label>
                                                                <Form.Control type="datetime-local" placeholder=""
                                                                    value={data.lat}
                                                                    onChange={(e) => handleFlChange(data.id, 'flight_lat', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className='w-50'>
                                                                <Form.Label>Ground Handler</Form.Label>
                                                                <Select
                                                                    options={groundHandlerOption}
                                                                    onChange={(e) => handleFlChange(data.id, 'ground_handler', e.value)}
                                                                    placeholder="--"
                                                                    className="autoslct w-100"
                                                                    name="ground_handler"
                                                                    value={groundHandlerOption?.find(option => option.value === formData?.ground_handler) || ''} 
                                                                    // value={groundHandlerOption?.find(option => option.value === data.ground_handler) || ''}

                                                                />
                                                            </div>
                                                        </div>
                                                    } */}
                                                    {/* <div className='text-end mt-2 dimension_add'>
                                                        <Button variant="primary" >+ Add</Button>
                                                    </div> */}
                                                </div>
                                                <div className='text-end mt-2 dimension_add'>
                                                    <Button variant="primary" >+ Add Flight</Button>
                                                </div>
                                            </>
                                        ))}

                                    </div>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Transport Information</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 2</b></p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Transport Type :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="transport_type"
                                                        value={formData.transport_type}
                                                        onChange={(e) => handleInputChange('transport_type', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Handler name :</span>
                                                <span>
                                                    <Select
                                                        // options={handlerOptions}
                                                        name="handler_name"
                                                        className="w-100 autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Delivery date/time :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="delivery_datetime"
                                                        value={formData.delivery_datetime}
                                                        onChange={(e) => handleInputChange('delivery_datetime', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Inspection Information</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 3</b></p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Number of Fyto's :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="transport_type"
                                                        value={formData.transport_type}
                                                        onChange={(e) => handleInputChange('transport_type', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Date :</span>
                                                <span>
                                                    <Select
                                                        // options={handlerOptions}
                                                        name="handler_name"
                                                        className="autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Start time :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="delivery_datetime"
                                                        value={formData.delivery_datetime}
                                                        onChange={(e) => handleInputChange('delivery_datetime', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>End time :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="delivery_datetime"
                                                        value={formData.delivery_datetime}
                                                        onChange={(e) => handleInputChange('delivery_datetime', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Short Remarks :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="transport_type"
                                                        value={formData.transport_type}
                                                        onChange={(e) => handleInputChange('transport_type', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Shipment Arrived</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 4</b></p>
                                        </div>
                                        <ul>
                                            <li className='d-flex'>
                                                <span>Shipment Arrived :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === "1"}
                                                        id='cipl-1' onChange={(e) => handleInputChange('ci_pl', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='cipl-2' onChange={(e) => handleInputChange('ci_pl', '0')}
                                                    />

                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipment Class :</span>
                                                <span>
                                                    <Select
                                                        options={VwsShipmentClass}
                                                        name="handler_name"
                                                        className="autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Warehouse In</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 5</b></p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Date :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="warehouse_in"
                                                        value={formData.warehouse_in}
                                                        onChange={(e) => handleInputChange('warehouse_in', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>DOC Type<span className='text-danger'>*</span> :</span>
                                                <span>
                                                    {/* <Form.Control
                                                type="text"
                                                name="doc_in"
                                                value={formData.doc_in}
                                                onChange={(e) => handleInputChange('doc_in', e.target.value)}
                                            /> */}
                                                    <Select
                                                        options={acceptanceWarehouseInhandlerOptions}
                                                        name="handler_name"
                                                        className="w-100 autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>DOC No :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="doc_in"
                                                        value={formData.doc_in}
                                                        onChange={(e) => handleInputChange('doc_in', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Location :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="warehouse_out"
                                                        value={formData.warehouse_out}
                                                        onChange={(e) => handleInputChange('warehouse_out', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Temperature :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="warehouse_out"
                                                        value={formData.warehouse_out}
                                                        onChange={(e) => handleInputChange('warehouse_out', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Split Shipment :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === "1"}
                                                        id='cipl-1' onChange={(e) => handleInputChange('ci_pl', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='cipl-2' onChange={(e) => handleInputChange('ci_pl', '0')}
                                                    />

                                                </span>
                                            </li>

                                        </ul>
                                    </div>
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Inspection Status</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 6</b></p>
                                        </div>
                                        <ul>
                                            <li className='d-flex'>
                                                <span>No Inspection :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === "1"}
                                                        id='cipl-1' onChange={(e) => handleInputChange('ci_pl', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='cipl-2' onChange={(e) => handleInputChange('ci_pl', '0')}
                                                    />

                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Approved :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === "1"}
                                                        id='cipl-1' onChange={(e) => handleInputChange('ci_pl', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='cipl-2' onChange={(e) => handleInputChange('ci_pl', '0')}
                                                    />

                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>On Hold :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === "1"}
                                                        id='cipl-1' onChange={(e) => handleInputChange('ci_pl', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='cipl-2' onChange={(e) => handleInputChange('ci_pl', '0')}
                                                    />

                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Rejected :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === "1"}
                                                        id='cipl-1' onChange={(e) => handleInputChange('ci_pl', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='cipl-2' onChange={(e) => handleInputChange('ci_pl', '0')}
                                                    />

                                                </span>
                                            </li>
                                            <li>
                                                <span>Europe Location :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="doc_out"
                                                        value={formData.doc_out}
                                                        onChange={(e) => handleInputChange('doc_out', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Release Information </h4>
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 7</b></p>

                                        </div>
                                        <ul className='checks'>
                                            <li>
                                                <span>ID Type:</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" />
                                                </span>
                                            </li>
                                            <li>
                                                <span>ID Number :</span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Release To:</span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Carrier Code:</span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Handler Name:</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Location:</span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Short Remarks:</span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                </span>
                                            </li>

                                        </ul>
                                    </div>
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Warehouse Out</h4>
                                            <p><FontAwesomeIcon icon={faCircle} className='pe-2 circle' /><b>Step 8</b></p>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Date/Time :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="delivery_datetime"
                                                        value={formData.delivery_datetime}
                                                        onChange={(e) => handleInputChange('delivery_datetime', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Doc Type :</span>
                                                <span>
                                                    <Select
                                                        options={acceptanceWarehouseInhandlerOptions}
                                                        name="handler_name"
                                                        className="autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Doc Number :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="transport_type"
                                                        value={formData.transport_type}
                                                        onChange={(e) => handleInputChange('transport_type', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>

                            </Row>
                        }
                        {selectedTab === 'customs' && (
                            <div>{/* Customs content here, or leave blank if not needed */}</div>
                        )}
                        {selectedTab === 'invoice' && (
                            <div>
                                <Row>
                                    <Col lg={12}>
                                        <div className='flbg invoice_dv'>
                                            <div className='invoice_hdr px-3'>
                                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                                    <h4><span className='pe-3'><img src={view} /></span>Health Inspection</h4>
                                                    <div className='button-group invoice_btn_grp'>
                                                        <Button><span className='pe-2'><img src={xls_file} /></span>Excel</Button>
                                                        <Button><span className='pe-2'><img src={mail} /></span>Email</Button>
                                                        <Button className='invoic_btn_active'><span className='pe-2'><img src={dwnld} /></span>PDF</Button>
                                                    </div>
                                                </div>
                                                <div className='d-flex justify-content-between align-items-center mb-3'>
                                                    <div>
                                                        <h4 className='mb-0'>Invoice</h4>
                                                        <p className='mb-0'>Invoice Number #INV - 1299-0000</p>
                                                    </div>
                                                    <div>
                                                        <img src={cargohub_logo} alt='' />
                                                    </div>

                                                </div>
                                            </div>
                                            <hr />
                                            <div className='invoice_bdy d-flex justify-content-between align-items-center mb-2 px-3'>
                                                <div>
                                                    <div>
                                                        <h6>Billed By:</h6>
                                                        <h6>FLowly</h6>
                                                        <p className='addrss'>789 Enterprise Aveneue, Floor 2, Metropolis, Country</p>
                                                    </div>
                                                    <div className='mt-4'>
                                                        <h6>Date Issued:</h6>
                                                        <p>January 17,2025</p>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div>
                                                        <h6>Billed To:</h6>
                                                        <h6>Brightstone Airline</h6>
                                                        <p className='addrss'>789 Enterprise Aveneue, Floor 2, Metropolis, Country</p>
                                                    </div>
                                                    <div className='mt-4'>
                                                        <h6>Date Issued:</h6>
                                                        <p>January 31,2025</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr />
                                            <div className='invoice_table px-3 text-center'>
                                                <h5 className='text-start'>Invoice Details</h5>
                                                <Table responsive borderless>
                                                    <thead>
                                                        <tr>
                                                            <th>NO</th>
                                                            <th>Category</th>
                                                            <th>Costs</th>
                                                            <th>TTL</th>
                                                            <th>VAT</th>
                                                            <th>VAT Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>2</td>
                                                            <td>VWA Costs Low</td>
                                                            <td>€ 500</td>
                                                            <td>€ 1000</td>
                                                            <td>21%</td>
                                                            <td>210</td>
                                                        </tr>
                                                        <tr>
                                                            <td>2</td>
                                                            <td>VWA Costs Low</td>
                                                            <td>€ 500</td>
                                                            <td>€ 1000</td>
                                                            <td>21%</td>
                                                            <td>210</td>
                                                        </tr>
                                                        <tr>
                                                            <td>2</td>
                                                            <td>VWA Costs Low</td>
                                                            <td>€ 500</td>
                                                            <td>€ 1000</td>
                                                            <td>21%</td>
                                                            <td>210</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </div>
                                            <hr />
                                            <div className='invoice_subtotal d-flex justify-content-end px-5 me-5'>
                                                <div>
                                                    <h6><span>Subtotal:</span><span>€150.00</span></h6>
                                                    <h6><span>VAT:</span><span>€100.00</span></h6>
                                                    <h5><span>Total:</span><span>€500.00</span></h5>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}
                        {(selectedButton === 'general' && selectedTab == 'details') &&
                            <Row>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details h-100'>
                                        <div className='ship_head'>
                                            <h4>Details</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                        </div>
                                        <ul className="list-unstyled">
                                            <li>
                                                <span>Master AirwayBill :</span>
                                                <span>
                                                    <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                        onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>HAWB :</span>
                                                <span>
                                                    <Form.Control type="text" name="hawb" value={formData.hawb}
                                                        onChange={(e) => handleInputChange('hawb', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Job no :</span>
                                                <span>
                                                    <Form.Control type="text" name="job_nr" value={formData.job_nr}
                                                        onChange={(e) => handleInputChange('job_nr', e.target.value)} />
                                                </span>
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <span className="me-2">Bonded : <span class="text-danger">*</span></span>
                                                <Form.Check type="radio" label="YES" name="bonded" value="1"
                                                    checked={formData.bonded === "1"}
                                                    onChange={() => handleInputChange('bonded', '1')} className="me-2" />
                                                <Form.Check type="radio" label="NO" name="bonded" value="0"
                                                    checked={formData.bonded === "0"}
                                                    onChange={() => handleInputChange('bonded', '0')} />
                                            </li>

                                            <li className="d-flex align-items-center">
                                                <span className="me-2">Health Inspection : <span class="text-danger">*</span></span>
                                                <Form.Check type="radio" label="YES" name="health_inspection" value="1"
                                                    checked={formData.health_inspection === "1"}
                                                    onChange={() => handleInputChange('health_inspection', '1')} className="me-2" />
                                                <Form.Check type="radio" label="NO" name="health_inspection" value="0"
                                                    checked={formData.health_inspection === "0"}
                                                    onChange={() => handleInputChange('health_inspection', '0')} />
                                            </li>

                                            <li>
                                                <span>Incoterm :</span>
                                                <span>
                                                    <Select
                                                        options={incotermOption}
                                                        onChange={(e) => handleInputChange('incoterm', e.value)}
                                                        value={incotermOption.find(opt => opt.value === formData.incoterm) || ''}
                                                        className="w-100" placeholder="--" />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Origin Airport :</span>
                                                <span>
                                                    <Select
                                                        options={getDestination}
                                                        onChange={(e) => handleInputChange('origin_airport', e.value)}
                                                        value={getDestination.find(opt => opt.value === formData.origin_airport) || ''}
                                                        className="w-100" placeholder="Origin" />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Shipper :</span>
                                                <span>
                                                    <Form.Control type="text" name="shipper" value={formData.shipper}
                                                        onChange={(e) => handleInputChange('shipper', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Consignee :</span>
                                                <span>
                                                    <Form.Control type="text" name="consignee" value={formData.consignee}
                                                        onChange={(e) => handleInputChange('consignee', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Reference :</span>
                                                <span>
                                                    <Form.Control type="text" name="reference" value={formData.reference}
                                                        onChange={(e) => handleInputChange('reference', e.target.value)} />
                                                </span>
                                            </li>


                                        </ul>

                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>

                                    {/* Transport Section */}
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Package Information</h4>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Gross Weight :</span>
                                                <span>
                                                    <Form.Control type="number" name="gross_weight" value={formData.gross_weight}
                                                        onChange={(e) => handleInputChange('gross_weight', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Chargeable Weight :</span>
                                                <span>
                                                    <Form.Control type="number" name="chargeable_weight" value={formData.chargeable_weight}
                                                        onChange={(e) => handleInputChange('chargeable_weight', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Volume :</span>
                                                <span>
                                                    <Form.Control type="number" name="volume" value={formData.volume}
                                                        onChange={(e) => handleInputChange('volume', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Packaging :</span>
                                                <span>
                                                    <Form.Control type="text" name="packaging" value={formData.packaging}
                                                        onChange={(e) => handleInputChange('packaging', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Expected Pcs :</span>
                                                <span>
                                                    <Form.Control type="number" name="expected_pcs" value={formData.expected_pcs}
                                                        onChange={(e) => handleInputChange('expected_pcs', e.target.value)} />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Expected Weight :</span>
                                                <span>
                                                    <Form.Control type="number" name="expected_weight" value={formData.expected_weight}
                                                        onChange={(e) => handleInputChange('expected_weight', e.target.value)} />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>

                                    {/* Warehouse In Section */}
                                    <div className='flbg details mb-3 '>
                                        <div className='ship_head'>
                                            <h4>Acceptance - Release</h4>
                                        </div>
                                        <ul>
                                            <li>
                                                <span><b>Warehouse In :</b></span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="warehouse_in"
                                                        value={formData.warehouse_in}
                                                        onChange={(e) => handleInputChange('warehouse_in', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                            <span>DOC Type<span className='text-danger'>*</span> :</span>
                                            <span>
                                            <Form.Control
                                                type="text"
                                                name="doc_in"
                                                value={formData.doc_in}
                                                onChange={(e) => handleInputChange('doc_in', e.target.value)}
                                            />
                                            </span>
                                        </li> */}
                                            <li>
                                                <span>Doc Type :<span class="text-danger">*</span></span>
                                                <span>
                                                    <Select
                                                        options={acceptanceWarehouseOuthandlerOptions}
                                                        name="handler_name"
                                                        className="autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>DOC No :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="doc_in"
                                                        value={formData.doc_in}
                                                        onChange={(e) => handleInputChange('doc_in', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <hr />
                                            <li>
                                                <span>Warehouse Out :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="warehouse_out"
                                                        value={formData.warehouse_out}
                                                        onChange={(e) => handleInputChange('warehouse_out', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li>
                                            <span>DOC Type<span className='text-danger'>*</span> :</span>
                                            <span>
                                            <Form.Control
                                                type="text"
                                                name="doc_out"
                                                value={formData.doc_out}
                                                onChange={(e) => handleInputChange('doc_out', e.target.value)}
                                            />
                                            </span>
                                        </li> */}
                                            <li>
                                                <span>Doc Type : <span class="text-danger">*</span></span>
                                                <span>
                                                    <Select
                                                        options={acceptanceWarehouseInhandlerOptions}
                                                        name="handler_name"
                                                        className="autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>DOC No  :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="doc_out"
                                                        value={formData.doc_out}
                                                        onChange={(e) => handleInputChange('doc_out', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>



                                </Col>
                                <Col lg={6} className='mb-3'>
                                    {/* <div className='flbg details mb-3'>  
                                        <div className='ship_head'>
                                        <h4>Financial Data</h4>
                                        </div>
                                        <ul className='financial'>
                                        <li>
                                            <span>Trucking :</span>
                                            <span className='d-flex gap-2'>
                                            <Form.Control
                                                type="number" placeholder="Buying" name="trucking_buying"
                                                value={formData.trucking_buying}
                                                onChange={(e) => handleInputChange('trucking_buying', e.target.value)}
                                            />
                                            <Form.Control
                                                type="number" placeholder="Selling" name="trucking_selling"
                                                value={formData.trucking_selling}
                                                onChange={(e) => handleInputChange('trucking_selling', e.target.value)}
                                            />
                                            <Select
                                                options={currencies}
                                                onChange={(e) => handleInputChange('trucking_currency', e.value)}
                                                className="autoslct"
                                                name="trucking_currency"
                                                value={currencies.find(opt => opt.value === formData.trucking_currency) || ''}
                                            />
                                            </span>
                                        </li>

                                        <li>
                                            <span>Courier :</span>
                                            <span className='d-flex gap-2'>
                                            <Form.Control
                                                type="number" placeholder="Buying" name="courier_buying"
                                                value={formData.courier_buying}
                                                onChange={(e) => handleInputChange('courier_buying', e.target.value)}
                                            />
                                            <Form.Control
                                                type="number" placeholder="Selling" name="courier_selling"
                                                value={formData.courier_selling}
                                                onChange={(e) => handleInputChange('courier_selling', e.target.value)}
                                            />
                                            <Select
                                                options={currencies}
                                                onChange={(e) => handleInputChange('courier_currency', e.value)}
                                                className="autoslct"
                                                name="courier_currency"
                                                value={currencies.find(opt => opt.value === formData.courier_currency) || ''}
                                            />
                                            </span>
                                        </li>

                                        <li>
                                            <span>DG :</span>
                                            <span className='d-flex gap-2'>
                                            <Form.Control
                                                type="number" placeholder="Buying" name="dg_buying"
                                                value={formData.dg_buying}
                                                onChange={(e) => handleInputChange('dg_buying', e.target.value)}
                                            />
                                            <Form.Control
                                                type="number" placeholder="Selling" name="dg_selling"
                                                value={formData.dg_selling}
                                                onChange={(e) => handleInputChange('dg_selling', e.target.value)}
                                            />
                                            <Select
                                                options={currencies}
                                                onChange={(e) => handleInputChange('dg_currency', e.value)}
                                                className="autoslct"
                                                name="dg_currency"
                                                value={currencies.find(opt => opt.value === formData.dg_currency) || ''}
                                            />
                                            </span>
                                        </li>
                                        </ul>
                                    </div> */}
                                    <div className='flbg details mb-3'>
                                        <div className='ship_head'>
                                            <h4>Flight Details</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                        </div>
                                        {/* <ul className='flight_details'>
                                            <li>
                                                <span>Haulier :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text" className='w-100' name='haulier' value={formData.haulier}
                                                        onChange={(e) => handleInputChange('haulier', e.target.value)}
                                                    />
                                                </span>
                                            </li>

                                            <li>
                                                <span>Instructions :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text" className='w-100' name='instructions' value={formData.instructions}
                                                        onChange={(e) => handleInputChange('instructions', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li><span>Reference nr :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text" className='w-100' name='delivery_reference_nr' value={formData.delivery_reference_nr}
                                                        onChange={(e) => handleInputChange('delivery_reference_nr', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Slottime :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local" className='w-100' name='slottime' value={formData.slottime}
                                                        onChange={(e) => handleInputChange('slottime', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Booked for delivery :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="booked_for_delivery" value="true" checked={formData.booked_for_delivery === "1"}
                                                        id='bfd-1' onChange={(e) => handleInputChange('booked_for_delivery', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="booked_for_delivery" value="false" checked={formData.booked_for_delivery === "0"}
                                                        id='bfd-2' onChange={(e) => handleInputChange('booked_for_delivery', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Delivered :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="delivered" value="true" checked={formData.delivered === "1"}
                                                        id='dlvrd-1' onChange={(e) => handleInputChange('delivered', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="delivered" value="false" checked={formData.delivered === "0"}
                                                        id='dlvrd-2' onChange={(e) => handleInputChange('delivered', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>POD received :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="pod_received" value="true" checked={formData.pod_received === "1"}
                                                        id='pod-1' onChange={(e) => handleInputChange('pod_received', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="pod_received" value="false" checked={formData.pod_received === "0"}
                                                        id='pod-2' onChange={(e) => handleInputChange('pod_received', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Remarks :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text" className='w-100' name='delivery_remarks' value={formData.delivery_remarks}
                                                        onChange={(e) => handleInputChange('delivery_remarks', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul> */}
                                        {formData?.flight_details?.map((data, index) => (
                                            <>
                                                <div className='flight_section mb-3'>
                                                    <div className='flex_gap'>
                                                        <h4>Flight {index + 1}</h4>
                                                        <div className='imag_trash ms-0 mt-0 align-items-center'>
                                                            {formData.flight_details.length > 1 && (
                                                                <img src={Trash} alt='' onClick={() => removeFlight(data.id)} />
                                                            )}
                                                        </div>
                                                    </div>
                                                    <ul className="list-unstyled">
                                                        <li>
                                                            <span>Airline Name:</span>
                                                            <span>
                                                                <Form.Control type="text" name="master_airwaybill" value={formData.master_airwaybill}
                                                                    onChange={(e) => handleInputChange('master_airwaybill', e.target.value)} />
                                                            </span>
                                                        </li>
                                                    </ul>


                                                    <div className='flex_gap'>
                                                        <div>
                                                            <Form.Label>Flight Number</Form.Label>
                                                            <div className='flex_gap'>
                                                                <Select
                                                                    options={getOwnerCodes}
                                                                    onChange={(e) => handleFlChange(data.id, 'flight_code', e.value)}
                                                                    placeholder="flight"
                                                                    className="autoslct"
                                                                    name="flight_code"
                                                                    value={getOwnerCodes.find(option => option.value === data?.flight_code) || ''}
                                                                />
                                                                {/* <Form.Control type="text" className='w-50' placeholder="" /> */}
                                                                <Form.Control type="text" className='fl_wd' placeholder=""
                                                                    value={data.flight_number}
                                                                    onChange={(e) => handleFlChange(data.id, 'flight_number', e.target.value)}
                                                                />
                                                            </div>

                                                        </div>
                                                        <div className='md_flight'>
                                                            <Form.Label>Flight Date</Form.Label>
                                                            <Form.Control type="date" placeholder=""
                                                                value={data.flight_date}
                                                                onChange={(e) => handleFlChange(data.id, 'flight_date', e.target.value)}
                                                            />
                                                        </div>
                                                        <div>
                                                            <Form.Label>Origin</Form.Label>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(e) => handleFlChange(data.id, 'origin', e.value)}
                                                                placeholder="origin"
                                                                className="autoslct"
                                                                name="origin"
                                                                value={getDestination.find(option => option.value === data?.origin) || ''}
                                                            />
                                                            {/* <Form.Control type="text" placeholder="" /> */}
                                                        </div>
                                                        <div>
                                                            <Form.Label>Destination</Form.Label>
                                                            <Select
                                                                options={getDestination}
                                                                onChange={(e) => handleFlChange(data.id, 'destination', e.value)}
                                                                placeholder="Destination"
                                                                className="autoslct"
                                                                name="destination"
                                                                value={getDestination.find(option => option.value === data?.destination) || ''}
                                                            />
                                                            {/* <Form.Control type="text" placeholder=""
                                                                value={data.width}
                                                                onChange={(e) => handleFlChange(data.id, 'width', e.target.value)}
                                                            /> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='text-end mt-2 dimension_add'>
                                                    <Button variant="primary" >+ Add Flight</Button>
                                                </div>
                                            </>
                                        ))}
                                        {/* 
                                        <div className='text-end mt-2 dimension_add'>
                                            <Button variant="primary" onClick={addFlight}>+ Add</Button>
                                        </div> */}
                                    </div>
                                    <div className='flbg details'>
                                        <div className='ship_head'>
                                            <h4>Transport</h4>
                                        </div>
                                        <ul>
                                            <li>
                                                <span>Transport Type :</span>
                                                <span>
                                                    <Form.Control
                                                        type="text"
                                                        name="transport_type"
                                                        value={formData.transport_type}
                                                        onChange={(e) => handleInputChange('transport_type', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Handler name :</span>
                                                <span>
                                                    <Select
                                                        // options={handlerOptions}
                                                        name="handler_name"
                                                        className="autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Delivery date/time :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local"
                                                        name="delivery_datetime"
                                                        value={formData.delivery_datetime}
                                                        onChange={(e) => handleInputChange('delivery_datetime', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>Shipment Type :</span>
                                                <span>
                                                    {/* <Form.Control
                                                    type="text"
                                                    name="shipment_type"
                                                    value={formData.shipment_type}
                                                    onChange={(e) => handleInputChange('shipment_type', e.target.value)}
                                                /> */}
                                                    <Select
                                                        options={TransportShipmentType}
                                                        name="handler_name"
                                                        className="autoslct"
                                                        // value={handlerOptions.find(opt => opt.value === formData.handler_name) || ''}
                                                        onChange={(e) => handleInputChange('handler_name', e.value)}
                                                    />
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                                <Col lg={6} className='mb-3'>
                                    <div className='flbg details h-100'>
                                        <div className='ship_head'>
                                            <h4>Checks</h4>
                                            {/* <Link to='#'>edit</Link> */}
                                        </div>
                                        <ul className='checks'>
                                            <li>
                                                <span>ETA :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local" className='' name='eta' value={formData.eta}
                                                        onChange={(e) => handleInputChange('eta', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>ATA :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local" className='' name='ata' value={formData.ata}
                                                        onChange={(e) => handleInputChange('ata', e.target.value)}
                                                    />
                                                </span>
                                            </li>
                                            <li>
                                                <span>NOA :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local" className='' name='noa' value={formData.noa}
                                                        onChange={(e) => handleInputChange('noa', e.target.value)}
                                                    />

                                                </span>
                                            </li>
                                            <li>
                                                <span>Pickup Airline :</span>
                                                <span>
                                                    <Form.Control
                                                        type="datetime-local" className='' name='pickup_airline' value={formData.pickup_airline}
                                                        onChange={(e) => handleInputChange('pickup_airline', e.target.value)}
                                                    />

                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Inbound WHS :</span>
                                                <span className='d-flex'>
                                                    <Form.Control
                                                        type="datetime-local" className='' name='inbound_whs' value={formData.inbound_whs}
                                                        onChange={(e) => handleInputChange('inbound_whs', e.target.value)}
                                                    />

                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>CI / PL :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="ci_pl" value="true" checked={formData.ci_pl === "1"}
                                                        id='cipl-1' onChange={(e) => handleInputChange('ci_pl', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="ci_pl" value="false" checked={formData.ci_pl === "0"}
                                                        id='cipl-2' onChange={(e) => handleInputChange('ci_pl', '0')}
                                                    />

                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>HS Code :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="hs_code" value="true" checked={formData.hs_code === "1"}
                                                        id='hsc-1' onChange={(e) => handleInputChange('hs_code', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="hs_code" value="false" checked={formData.hs_code === "0"}
                                                        id='hsc-2' onChange={(e) => handleInputChange('hs_code', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>ATR / REX :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="atr_rex" value="true" checked={formData.atr_rex === "1"}
                                                        id='atr-1' onChange={(e) => handleInputChange('atr_rex', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="atr_rex" value="false" checked={formData.atr_rex === "0"}
                                                        id='atr-2' onChange={(e) => handleInputChange('atr_rex', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>ATR received :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="atr_received" value="true" checked={formData.atr_received === "1"}
                                                        id='atrr-1' onChange={(e) => handleInputChange('atr_received', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="atr_received" value="false" checked={formData.atr_received === "0"}
                                                        id='atrr-2' onChange={(e) => handleInputChange('atr_received', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Quote received :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="quote_received" value="true" checked={formData.quote_received === "1"}
                                                        id='qr-1' onChange={(e) => handleInputChange('quote_received', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="quote_received" value="false" checked={formData.quote_received === "0"}
                                                        id='qr-2' onChange={(e) => handleInputChange('quote_received', '0')}
                                                    />
                                                </span>
                                            </li>
                                            {/* <li className='d-flex'>
                                                <span>Received DN :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="received_dn" value="true" checked={formData.received_dn === "1"}
                                                        id='rd-1' onChange={(e) => handleInputChange('received_dn', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="received_dn" value="false" checked={formData.received_dn === "0"}
                                                        id='rd-2' onChange={(e) => handleInputChange('received_dn', '0')}
                                                    />
                                                </span>
                                            </li>
                                            <li className='d-flex'>
                                                <span>Invoice :</span>
                                                <span className='d-flex'>
                                                    <Form.Check
                                                        type="radio" label="Yes" name="invoiced" value="true" checked={formData.invoiced === "1"}
                                                        id='inv-1' onChange={(e) => handleInputChange('invoiced', '1')}
                                                    />
                                                    <Form.Check
                                                        type="radio" label="No" name="invoiced" value="false" checked={formData.invoiced === "0"}
                                                        id='inv-2' onChange={(e) => handleInputChange('invoiced', '0')}
                                                    />
                                                </span>
                                            </li> */}

                                        </ul>
                                    </div>
                                </Col>
                            </Row>
                        }
                        {selectedButton === 'attachment' &&
                            <div className='flbg'>
                                <div className='all_file mb-3'>
                                    <h4>All files</h4>
                                    <Button variant="primary" onClick={imageModalUpload}> <img src={Uploadw} /> Upload file</Button>
                                    <input
                                        type="file"
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onChange={(e) => handleFileChange(e, 'A')}
                                        multiple
                                    />
                                </div>
                                <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="attach_tab">
                                    <Tab eventKey="All" title={<span>View All </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.map((data, index) => {
                                                    const fileName = data.file_name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();

                                                    return (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td><div className='file_attch'>
                                                                {["jpeg", "jpg", "png", "webp"].includes(data.file_path?.split(".")[data.file_path?.split(".").length - 1]
                                                                ) ? (
                                                                    <>
                                                                        <div className='file_icon'>
                                                                            <img
                                                                                src={data.file_path}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "22px",
                                                                                    maxHeight: "22px",
                                                                                    marginRight: "10px",
                                                                                }}
                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                            // onClick={() => handleFileClick(data.file_path)}
                                                                            />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                        {/* <span> */}
                                                                        {/*data.file_name*/}
                                                                        {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                                                        {/* </span> */}

                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className='file_icon'>
                                                                            <FontAwesomeIcon icon={faFileLines} />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{data.file_name}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                        {/* <span className="d-flex rafilename">
                                                                            <img src={Docmnt} className="fileimg" />
                                                                            <span>{data.file_name}</span>
                                                                        </span> */}
                                                                    </>
                                                                )}
                                                            </div>
                                                                {/* <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div> */}
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic" disabled={data.remarks_attachment === 1}>
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    )
                                                })}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Documents" title={<span>Documents </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["doc", "docx", "txt"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Spreadsheets" title={<span>Spreadsheets </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["xls", "xlsx", "csv"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="pdfs" title={<span>PDF's </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["pdf"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => (
                                                        <tr>
                                                            <td>
                                                                <Form.Check // prettier-ignore
                                                                    type="checkbox"
                                                                    id="checkbox"
                                                                // checked={selectedRows.some(
                                                                //     (row) => row.attachment_id === file.id
                                                                // )}
                                                                // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td className="delimg">
                                                                <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                            </td>
                                                            <td>
                                                                <div className='file_attch'>
                                                                    <div className='file_icon'>
                                                                        <FontAwesomeIcon icon={faFileLines} />
                                                                    </div>
                                                                    <div className='file_text'>
                                                                        <p>{data.file_name}</p>
                                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td><p>{data.category[0]}</p></td>
                                                            <td>
                                                                <p>{data.modified_name}</p>
                                                                <span>{data.modified_email}</span>
                                                            </td>
                                                            <td>
                                                                <span>{data.last_modified}</span>
                                                            </td>
                                                            <td>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                        <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                        <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                    <Tab eventKey="Images" title={<span>Images </span>} className='moveto'>
                                        <Table className='record_table'>
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th></th>
                                                    <th>File Name</th>
                                                    <th>Type</th>
                                                    <th>Uploaded by</th>
                                                    <th>last modified</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.attachments?.filter(data => ["jpg", "jpeg", "png", "bmp"].includes(data.file_ext.toLowerCase()))
                                                    .map((data, index) => {
                                                        const fileName = data.file_name;
                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                        const extension = fileName?.split(".").pop();

                                                        return (
                                                            <tr>
                                                                <td>
                                                                    <Form.Check // prettier-ignore
                                                                        type="checkbox"
                                                                        id="checkbox"
                                                                    // checked={selectedRows.some(
                                                                    //     (row) => row.attachment_id === file.id
                                                                    // )}
                                                                    // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                                                                    />
                                                                </td>
                                                                <td className="delimg">
                                                                    <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                                                                </td>
                                                                <td>
                                                                    <div className='file_attch'>
                                                                        <div className='file_icon'>
                                                                            <img
                                                                                src={data.file_path}
                                                                                alt="Preview"
                                                                                style={{
                                                                                    maxWidth: "22px",
                                                                                    maxHeight: "22px",
                                                                                    marginRight: "10px",
                                                                                }}
                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                            // onClick={() => handleFileClick(data.file_path)}
                                                                            />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{data.file_name}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                        {/* <span> */}
                                                                        {/*data.file_name*/}
                                                                        {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                                                        {/* </span> */}
                                                                    </div>
                                                                    {/* <div className='file_attch'>
                                                                        <div className='file_icon'>
                                                                            <FontAwesomeIcon icon={faFileLines} />
                                                                        </div>
                                                                        <div className='file_text'>
                                                                            <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                                            <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                                        </div>
                                                                    </div> */}
                                                                </td>
                                                                <td><p>{data.category[0]}</p></td>
                                                                <td>
                                                                    <p>{data.modified_name}</p>
                                                                    <span>{data.modified_email}</span>
                                                                </td>
                                                                <td>
                                                                    <span>{data.last_modified}</span>
                                                                </td>
                                                                <td>
                                                                    <Dropdown>
                                                                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                                            <FontAwesomeIcon icon={faEllipsisVertical} />
                                                                        </Dropdown.Toggle>

                                                                        <Dropdown.Menu>
                                                                            {/* <Dropdown.Item href="#/action-1">Edit</Dropdown.Item> */}
                                                                            <Dropdown.Item onClick={() => handleOpenModal('D', data)}>Delete</Dropdown.Item>
                                                                            <Dropdown.Item onClick={() => handleOpenModal('S', data)}>Set Type</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                            </tbody>
                                        </Table>
                                    </Tab>
                                </Tabs>
                            </div>
                        }
                        {selectedButton === 'remarks' &&
                            <div className='chat_bg'>
                                <div className='flbg right_side record_remarks'>
                                    <div className='chat_box'>
                                        {formData?.remarks?.map((msg, index) => (
                                            <>
                                                <Accordion key={index} activeKey={expandedKeys}>
                                                    <Accordion.Item eventKey={index.toString()}>
                                                        <Accordion.Header onClick={() => toggleAccordionItem(index, msg, 'all')} className=''>
                                                            <div className='position-relative'><img src={Pack} /> {msg.created_by}</div>
                                                            <div className='acorright'> {msg.attachments?.length > 0 && <FontAwesomeIcon icon={faPaperclip} />} <span>{msg.date} | {msg.time}</span></div></Accordion.Header>
                                                        <Accordion.Body>
                                                            {msg.message}
                                                            {msg.attachments?.length > 0 &&
                                                                <div className='d-flex mt-1 '>
                                                                    {msg.attachments?.map((file, index) => {
                                                                        const fileName = file?.file_name;
                                                                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                                        const extension = fileName?.split(".").pop();
                                                                        return (
                                                                            <>
                                                                                <div key={`ns_${index}`} className="mag_image">
                                                                                    {["jpeg", "jpg", "png", "webp"].includes(file.file_path?.split(".")[file.file_path?.split(".").length - 1]
                                                                                    ) ? (
                                                                                        <>
                                                                                            <img
                                                                                                src={file.file_path}
                                                                                                alt="Preview"
                                                                                                className=''
                                                                                                style={{
                                                                                                    maxWidth: "30px",
                                                                                                    maxHeight: "30px",
                                                                                                    marginRight: "5px",
                                                                                                }}
                                                                                            // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                                                                            // onClick={() =>
                                                                                            //     handleFileClick(file.file_path)
                                                                                            // }
                                                                                            />
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            <span className="d-flex rafilename">
                                                                                                <img src={Docmnt} className="fileimg" />
                                                                                            </span>
                                                                                        </>
                                                                                    )}
                                                                                    <span className="rafilename">
                                                                                        {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                                                    </span>
                                                                                    <button
                                                                                        className="msg_download"
                                                                                        type="button"
                                                                                        onClick={() =>
                                                                                            handleDownload(file.file_path, file.file_name)
                                                                                        }
                                                                                    >
                                                                                        <FontAwesomeIcon icon={faFileArrowDown} />
                                                                                    </button>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}
                                                                </div>
                                                            }
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                </Accordion>
                                            </>
                                        ))}
                                    </div>
                                    <div>
                                        <Form.Group className='massge_text'>
                                            <div className='mag_send'>
                                                <Link to='#' onClick={handleBrowseFiles}> <FontAwesomeIcon icon={faPaperclip} /> </Link>
                                                {/* <Button variant="primary" onClick={() => sendMessage(selectedButton)} ><FontAwesomeIcon icon={faPaperPlane} /></Button> */}
                                                {/* <button className='btn btn-primary drpbtn'>Browse Files</button> */}
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    style={{ display: 'none' }}
                                                    onChange={(e) => handleFileChange(e, 'R')}
                                                    multiple
                                                />
                                            </div>
                                            <div className='d-flex reco_image'>
                                                {rfiles.map((file, index) => {
                                                    const fileName = file?.file_name;
                                                    const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                                                    const extension = fileName?.split(".").pop();
                                                    return (
                                                        <div key={index} className='img-thumbnail'>
                                                            {file?.type?.startsWith('image/') ? (
                                                                <img
                                                                    // src={URL.createObjectURL(file)}
                                                                    src={file.base64}
                                                                    alt="Preview"
                                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                                />
                                                            ) : (
                                                                <span className=''><img src={Docmnt} className='fileimg' />  </span>
                                                            )}
                                                            <span className="rafilename">
                                                                {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 7)}... .${extension}`}
                                                            </span>
                                                            <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index, 'R')}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                            <div>
                                                <Form.Control
                                                    as="textarea"
                                                    placeholder='Enter a description...'
                                                    rows={2}
                                                    name='message'
                                                    onChange={conversationChange}
                                                    value={sendData?.message || ''}
                                                // disabled={isSwitchOn === true}
                                                />
                                            </div>
                                        </Form.Group>
                                    </div>
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
            </div>

            {/* <div className="text-center mt-3 mb-3">
                <button type="button" className="stk_cancel btn btn-light" onClick={() => window.location.href = '/ForwarderShipments/ShipmentRecords'}>CANCEL</button>
                <button type="button" className="stk_save posr btn btn-primary" onClick={() => handleSubmit('S')} >{shId ? 'UPDATE' : 'Submit'}</button>
            </div> */}

            <Modal show={typeModal} onHide={() => { setTypeModal(false); }} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h3>{modalSection === 'S' ? 'Attachment Type' : 'Remove Attachment'}</h3>
                    <p>{modalSection === 'S' ? 'Update this attachment type' : 'Are you sure you want delete this attachment?'}</p>
                    {modalSection === 'S' &&
                        <Form.Group className="me-2">
                            <Form.Select aria-label="Select" onChange={(e) => modalChange(e)} value={typeData || "0"}>
                                <option value="0">Select</option>
                                <option value="Invoice">Invoice</option>
                                <option value="Packinglist">Packinglist</option>
                                <option value="Emails">Emails</option>
                                <option value="HAWB">HAWB</option>
                                <option value="MAWB">MAWB</option>
                                <option value="Manifest">Manifest</option>
                                <option value="Customs">Customs</option>
                                <option value="Proposal">Proposal</option>
                                <option value="Other">Other</option>
                            </Form.Select>
                        </Form.Group>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        {modalSection === 'S' ?
                            <Button variant="primary" onClick={modalUpdate}>
                                Update
                            </Button>
                            :
                            <>
                                <Button variant="secondary" onClick={() => setTypeModal(false)}>
                                    No
                                </Button>
                                <Button variant="primary" onClick={modalUpdate}>
                                    Yes
                                </Button>
                            </>
                        }
                    </div>
                </Modal.Footer>
            </Modal>
            <Modal show={showModalUpload} onHide={closeModalUpload} className='addfrom change_type' centered>
                <Modal.Header closeButton>
                    <div className='modal-title h4'>Upload Attachments</div>
                    <p className='text-start'>Drag and drop or browse to upload your attachments.</p>
                </Modal.Header>
                <Modal.Body>
                    <div className='type_work'>

                        <div className='ra_condition'>
                            <div
                                className='dropfile'
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                <img src={Shipupload} alt="upload" />
                                <h3>Drag and drop files here</h3>
                                <p>Or</p>
                                <button className='btn btn-primary drpbtn' onClick={uploadTarget ? (e) => handleBrowseFiles(e, uploadTarget) : handleBrowseFiles}>Browse Files</button>
                                <span>Maximum file size 25 MB</span>
                                <input
                                    type="file"
                                    ref={(el) => {
                                        if (uploadTarget) {
                                            fileInputRefs.current[uploadTarget] = el;
                                        }
                                    }}
                                    style={{ display: 'none' }}
                                    onChange={uploadTarget ? (e) => handleFileChange(e, 'C', uploadTarget) : (e) => handleFileChange(e, 'A')}
                                    multiple
                                />
                            </div>
                            <div className='attach_shipment'>
                                {files.map((file, index) => (
                                    <div key={index} className='uploadfil'>
                                        {file.base64.includes('image') ? (
                                            <>
                                                <img
                                                    src={file.base64}
                                                    alt="Preview"
                                                    style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                                                />
                                                <span>{file.file_name}</span>
                                            </>
                                        ) : (
                                            <>  <img src={Docmnt} className='fileimg' /> <span> {file.file_name}</span> </>
                                        )}
                                        <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex w-50 mx-auto are_bottom'>
                        <Button variant="primary" onClick={imageUpload}>
                            Upload
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

const ExpectedDetails = () => {
    return (
        <>
            <div className="">
                {/* {console.log('handlerList', handlerList)} */}
                <Header page_type='fsm' logo_url='/ForwarderShipments/ShipmentRecords' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <Link to="/ForwarderShipments/Import" className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        <div className='mb-3 mt-3'>
                            <Import />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ExpectedDetails;